module.exports = __webpack_public_path__ + "res/arrow_img.png";